// import lottie from "lottie-web";

export default class Loader {
  constructor(ctrl) {
    this.$loader = $(".loader");
    this.controller = ctrl;
  }

  init() {
    let self = this;

    if(!this.$loader.length) {
      self.controller.enabled(true);
      self.controller.update(true);
      return;
    }

    $('html').addClass('overflow-hidden');
    let $el = this.$loader.find("[data-lottie]");
    let data = $el.data("lottie");

    window.onbeforeunload = () => {
      self.$loader.find("img").css("display", "block");
      self.$loader.addClass("show");
    };

    if(sessionStorage.getItem("loaded")) {
      setTimeout(() => {
        self.$loader.addClass("hide");
        self.controller.enabled(true);
        self.controller.update(true);
        setTimeout(() => {
          $('html').removeClass('overflow-hidden');
        }, 400);
      }, 1000);
      return;
    }

    if(data !== undefined) {
      let lottie_anim = lottie.loadAnimation({
        container: $el[0],
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: data
      });

      lottie_anim.addEventListener("complete", () => {
        lottie_anim.pause();
        self.$loader.addClass("hide");
        $('html').removeClass('overflow-hidden');

        setTimeout(() => {
          self.controller.enabled(true);
          self.controller.update(true);
          sessionStorage.setItem("loaded", "true");
          lottie_anim.destroy();
        }, 400);

      });
    } else {
      setTimeout(() => {
        self.$loader.addClass("hide");
        $('html').removeClass('overflow-hidden');
        self.controller.enabled(true);
        self.controller.update(true);
        sessionStorage.setItem("loaded", "true");
      }, 1000);
    }
  }
}


// WEBPACK FOOTER //
// ./static/js/components/Loader.js